import {
  getFanMemberBySlug,
  getFanMemberFromPath,
  fanPath,
} from '../config/fanMembersConfig';

export function resolvePageContext({ fixedFanSlug, fixedActivityType, fixedId, params = {} }) {
  const fanMember = fixedFanSlug
    ? getFanMemberBySlug(fixedFanSlug)
    : getFanMemberFromPath(window.location.pathname);

  if (fanMember) {
    return {
      fanMember,
      activityId: fanMember.activityId,
      activityType: 'fan',
      isFanMemberRoute: true,
      navigateTo: (segment) => fanPath(fanMember.slug, segment),
    };
  }

  const activityId = fixedId || params.activityId || params.id;
  const activityType = fixedActivityType || params.activityType;

  return {
    fanMember: null,
    activityId,
    activityType,
    isFanMemberRoute: false,
    navigateTo: (segment) => `/${activityType}/${activityId}${segment ? `/${segment}` : ''}`,
  };
}

export function fanMemberHomePath(pathname) {
  const fanMember = getFanMemberFromPath(pathname);
  return fanMember ? fanPath(fanMember.slug) : null;
}

export function fanMemberMemberPath(pathname) {
  const fanMember = getFanMemberFromPath(pathname);
  return fanMember ? fanPath(fanMember.slug, 'member') : null;
}

/** Registration entry path for the current page context. */
export function resolveRegisterPath({ isFanMemberRoute, navigateTo, activityType, activityId }) {
  if (isFanMemberRoute) {
    return navigateTo();
  }
  return `/${activityType}/${activityId}/register`;
}
